import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHECK_INTERVAL = 30000;
const TIMEOUT_MS = 5000;

export function useHealthCheck() {
  const [status, setStatus] = useState("checking");
  const intervalRef = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        await axios.get(`${API}/health`, { timeout: TIMEOUT_MS });
        setStatus("online");
      } catch {
        setStatus("offline");
      }
    };

    check();
    intervalRef.current = setInterval(check, CHECK_INTERVAL);
    return () => clearInterval(intervalRef.current);
  }, []);

  return status;
}
